import {UserIcon} from '@backstage/core-components';
import {useTranslationRef} from '@backstage/frontend-plugin-api';
import {EntityRefLinks} from '@backstage/plugin-catalog-react';
import Button from '@material-ui/core/Button';
import {makeStyles, Theme} from '@material-ui/core/styles';
import {scaffolderReactTranslationRef} from '@backstage/plugin-scaffolder-react/alpha';


const useStyles = makeStyles<Theme>(theme => ({
    footer: {
        display: 'flex',
        justifyContent: 'space-between',
        flex: 1,
        alignItems: 'center',
    },
    ownedBy: {
        display: 'flex',
        alignItems: 'center',
        flex: 1,
        color: theme.palette.link,
    },
    actionContainer: {padding: '16px', flex: 1, alignItems: 'flex-end'},
}));


export interface AppTemplateCardActionsProps {
    ownedByRelations: any;
    canCreateTask: boolean;
    handleChoose: () => void;
}

export const AppTemplateCardActions = ({
                                           canCreateTask,
                                           handleChoose,
                                           ownedByRelations,
                                       }: AppTemplateCardActionsProps) => {
    const {t} = useTranslationRef(scaffolderReactTranslationRef);
    const styles = useStyles();

    return (
        <div className={styles.footer} data-testid="template-card-actions--footer">
            <div
                className={styles.ownedBy}
                data-testid="template-card-actions--ownedby"
            >
                {ownedByRelations.length > 0 && (
                    <>
                        <UserIcon fontSize="small"/>
                        <EntityRefLinks
                            style={{marginLeft: '8px'}}
                            entityRefs={ownedByRelations}
                            defaultKind="Group"
                            hideIcons
                        />
                    </>
                )}
            </div>
            {canCreateTask ? (
                <Button
                    size="small"
                    variant="outlined"
                    color="primary"
                    data-testid="template-card-actions--create"
                    onClick={handleChoose}
                >
                    {t('templateCard.chooseButtonText')}
                </Button>
            ) : null}
        </div>
    );
};

